export default __webpack_public_path__ + "static/media/10n.77e5b507.svg";